var graphic = document.getElementById("graphics");
function setIn(element) {
    $(".zoom").removeClass("in");
    $(".group").removeClass("in");
    $(element).addClass("in");
    $(element).parents(".group").addClass("in");
}

function moveToSelf(origin) {
    $(origin).on("click", function () {
        $("body").addClass("zoomed").addClass(this.id);
        setIn(this);
        console.log(this.getBBox());
        var s = this.getBBox();
        var amt = 25;
        newView =
            "" +
            (s.x - amt) +
            " " +
            (s.y - amt) +
            " " +
            (s.width + amt * 2) +
            " " +
            (s.height + amt * 2);
        console.log(newView);
        TweenMax.to(graphic, 0.5, {
            attr: { viewBox: newView },
            ease: Circ.easeOut,
        });
    });
}

function moveChart(origin) {
    $(origin).on("click", function (e) {
        end = $(this).data("goto");
        console.log($(this)[0], end);
        $("body").addClass("zoomed").addClass(end);
        setIn("#" + end);

        console.log("moveChart", origin, end);
        var moveTo = document.getElementById(end);
        var s = moveTo.getBBox();
        var amt = 25;
        newView =
            "" +
            (s.x - amt) +
            " " +
            (s.y - amt) +
            " " +
            (s.width + amt * 2) +
            " " +
            (s.height + amt * 2);
        console.log("moveChart", newView);

        TweenMax.to(graphic, 0.5, {
            attr: { viewBox: newView },
            ease: Circ.easeOut,
        });
        e.preventDefault();
    });
}

function moveTwice(origin, mid, end) {
    $(origin).on("click", function () {
        var moveMid = document.getElementById(mid);
        var moveEnd = document.getElementById(end);
        var endRect = "#" + end + " path";
        var m = moveMid.getBBox();
        var e = moveEnd.getBBox();
        var amt = 25;
        midView =
            "" +
            (m.x - amt) +
            " " +
            (m.y - amt) +
            " " +
            (m.width + amt * 2) +
            " " +
            (m.height + amt * 2);
        endView =
            "" +
            (e.x - amt) +
            " " +
            (e.y - amt) +
            " " +
            (e.width + amt * 2) +
            " " +
            (e.height + amt * 2);
        var tl = new TimelineLite();
        tl.to(graphic, 1.5, {
            attr: { viewBox: midView },
            ease: Circ.easeOut,
        });
        tl.to(
            graphic,
            1.5,
            {
                attr: { viewBox: endView },
                ease: Circ.easeOut,
            },
            "+=1"
        );
        tl.fromTo(
            endRect,
            1,
            {
                fill: "#242326",
            },
            {
                fill: "#468391",
                ease: Circ.easeOut,
            }
        );
    });
}

function endChart(origin, end) {
    $(origin).on("click", function () {
        var moveTo = document.getElementById(end);
        var aRect = "#" + end + " path";
        var s = moveTo.getBBox();
        var amt = 25;
        newView =
            "" +
            (s.x - amt) +
            " " +
            (s.y - amt) +
            " " +
            (s.width + amt * 2) +
            " " +
            (s.height + amt * 2);
        var tl = new TimelineLite();
        tl.to(graphic, 1.5, {
            attr: { viewBox: newView },
            ease: Circ.easeOut,
        });
        tl.fromTo(
            aRect,
            1,
            {
                fill: "#242326",
            },
            {
                fill: "#468391",
                ease: Circ.easeOut,
            }
        );
    });
}

function setViewBox(newView) {
    newView = newView != null ? newView : "75 50 250 350";
    console.log("setViewBox", newView);

    TweenMax.to(graphic, 0.5, {
        attr: { viewBox: newView },
        ease: Circ.easeOut,
    });
}

moveToSelf(".group:not(#c) .zoom:not(#model)");
moveChart(".control");
$("#zoomOut, #model").on("click", function () {
    $("body").removeClass();
    $(".zoom").removeClass("in");
    $(".group").removeClass("in");
    var moveTo = document.getElementById("model");
    var s = moveTo.getBBox();
    var amt = 25;
    newView =
        "" +
        (s.x - amt) +
        " " +
        (s.y - amt) +
        " " +
        (s.width + amt * 2) +
        " " +
        (s.height + amt * 2);

    newView = "-75 -250 2025 750";
    TweenMax.to(graphic, 0.5, {
        attr: { viewBox: newView },
        ease: Circ.easeOut,
    });
});

// C-wheel
var index = 0;
var wheelElements = $("#c-wheel .zoom").length;
$(".group#c .zoom").on("click", function () {
    $("body").addClass("zoomed").addClass(this.id);
    setIn(this);
    setViewBox("815 -75 180 210");
});

$(".c-rotate-ccw").on("click", function () {
    index += 1;
    $("#c-wheel").css(
        "transform",
        "rotate(" + index * (360 / wheelElements) + "deg)"
    );
});
$(".c-rotate-cw").on("click", function () {
    index -= 1;
    $("#c-wheel").css(
        "transform",
        "rotate(" + index * (360 / wheelElements) + "deg)"
    );
});
